export default [
  { title: 'Org Details', url: '/manage/org/details' },
  { title: 'Sites', url: '/manage/org/sites' },
];
